export const BREAKDOWN_REASONS = {
	busFailure: 'busFailure',
	driverFatigue: 'driverFatigue',
	driverOutOfHours: 'driverOutOfHours',
};

export const BREAKDOWN_REASON_LABELS = {
	[BREAKDOWN_REASONS.busFailure]: 'Bus failure',
	[BREAKDOWN_REASONS.driverFatigue]: 'Driver fatigue',
	[BREAKDOWN_REASONS.driverOutOfHours]: 'Driver out of hours',
};

export const REASONS_REQUIRING_ABSENCE = [BREAKDOWN_REASONS.driverFatigue];
